import React from "react";
import moment from "moment";
import { Filters, GraphControl, DatepickerLabel, Accordion } from "./style.js";
import { Dropdown, Icon } from "semantic-ui-react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import "react-select/dist/react-select.css";

export default class ObservationsFilters extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.toggleOpen = this.toggleOpen.bind(this);
  }

  toggleOpen() {
    this.setState({
      open: !this.state.open,
    });
  }

  render() {
    return (
      <div>
        <Filters className={!this.state.open && "closed"}>
          <h3>Filters and settings</h3>
          <GraphControl>
            <div>
              <div>Observation area</div>
              <Dropdown
                placeholder="Any observation area"
                multiple
                search
                selection
                value={this.props.state.observationAreas}
                onChange={(event, data) => {
                  this.props.handleStateChange("observationAreas", data.value);
                }}
                options={this.props.observationAreas.map(area => {
                  return { key: area, value: area, text: area };
                })}
              />
              <div>Observer</div>
              <Dropdown
                placeholder="Any observer"
                multiple
                search
                selection
                value={this.props.state.observers}
                onChange={(event, data) => {
                  this.props.handleStateChange("observers", data.value);
                }}
                options={this.props.observerNames.map(observer => {
                  return { key: observer, value: observer, text: observer };
                })}
              />
              <div>Domain</div>
              <Dropdown
                placeholder="Any domain"
                multiple
                search
                selection
                value={this.props.state.domains}
                onChange={(event, data) => {
                  this.props.handleStateChange("domains", data.value);
                }}
                options={[
                  "Briefing",
                  "Inquiry & Rebriefing",
                  "Assertion & Challenge",
                  "Structured Communication",
                  "Closing the Loop",
                  "Debriefing",
                ].map(domain => {
                  return { key: domain, value: domain, text: domain };
                })}
              />
              <div>Rating</div>
              <Dropdown
                placeholder="Any rating"
                multiple
                search
                selection
                value={this.props.state.ratings}
                onChange={(event, data) => {
                  this.props.handleStateChange("ratings", data.value);
                }}
                options={[5, 4, 3, 2, 1].map(rating => {
                  return { key: rating, value: rating, text: rating };
                })}
              />
            </div>
            <div>
              <div>Data grouping</div>
              <Select
                placeholder="No grouping"
                value={this.props.state.grouping}
                onChange={data => {
                  this.props.handleStateChange("grouping", data ? data.value : data);
                }}
                options={[
                  {
                    value: "MONTHLY",
                    label: "Monthly",
                  },
                ]}
              />
            </div>
            <div>
              <DatepickerLabel>Start date</DatepickerLabel>
              <DatePicker
                selected={this.props.state.start}
                startDate={this.props.state.start}
                endDate={this.props.state.end}
                onChange={date => {
                  this.props.handleStateChange("start", date);
                }}
                minDate={this.props.observationsFirst}
                maxDate={this.props.state.end}
                inline
              />
            </div>
            <div>
              <DatepickerLabel>End date</DatepickerLabel>
              <DatePicker
                selected={this.props.state.end}
                startDate={this.props.state.start}
                endDate={this.props.state.end}
                onChange={date => {
                  this.props.handleStateChange("end", date);
                }}
                minDate={this.props.state.start}
                maxDate={moment()}
                inline
              />
            </div>
          </GraphControl>
        </Filters>
        <Accordion onClick={this.toggleOpen}>
          Filters and settings <Icon name={this.state.open ? "angle up" : "angle down"} />
        </Accordion>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Observations/components/ObservationFilters/index.jsx